import __vue_component__ from '../Form/TextField.vue.js';
import CalendarIcon from '../Icon/CalendarIcon.js';
import isValid from '../../node_modules/date-fns/esm/isValid/index.js';
import format from '../../node_modules/date-fns/esm/format/index.js';
import startOfWeek from '../../node_modules/date-fns/esm/startOfWeek/index.js';
import startOfMonth from '../../node_modules/date-fns/esm/startOfMonth/index.js';
import endOfMonth from '../../node_modules/date-fns/esm/endOfMonth/index.js';
import startOfYear from '../../node_modules/date-fns/esm/startOfYear/index.js';
import endOfYear from '../../node_modules/date-fns/esm/endOfYear/index.js';
import endOfWeek from '../../node_modules/date-fns/esm/endOfWeek/index.js';
import fromUnixTime from '../../node_modules/date-fns/esm/fromUnixTime/index.js';
import getTime from '../../node_modules/date-fns/esm/getTime/index.js';
import isAfter from '../../node_modules/date-fns/esm/isAfter/index.js';
import isBefore from '../../node_modules/date-fns/esm/isBefore/index.js';
import subDays from '../../node_modules/date-fns/esm/subDays/index.js';
import parse from '../../node_modules/date-fns/esm/parse/index.js';
import subMonths from '../../node_modules/date-fns/esm/subMonths/index.js';
import subWeeks from '../../node_modules/date-fns/esm/subWeeks/index.js';
import subYears from '../../node_modules/date-fns/esm/subYears/index.js';
import __vue_component__$1 from './Calendar.vue.js';
import __vue_component__$2 from '../common/Popup.vue.js';
import __vue_component__$3 from '../Dropdown/DropdownItem.vue.js';
import __vue_component__$4 from '../Dropdown/DropdownGroup.vue.js';

//
const MILISECONDS_IN_SECOND = 1000;
var script = {
  name: 'DateRangePicker',
  components: {
    TextField: __vue_component__,
    Calendar: __vue_component__$1,
    Popup: __vue_component__$2,
    CalendarIcon,
    DropdownItem: __vue_component__$3,
    DropdownGroup: __vue_component__$4
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        from: undefined,
        to: undefined
      })
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    dateFormat: {
      type: String,
      default: 'dd/MM/y'
    },
    showQuickRanges: {
      type: Boolean,
      default: true
    },
    disabledRange: {
      type: Object,
      default: () => ({
        from: undefined,
        to: undefined
      })
    },
    timeZone: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      focused: false,
      isOpen: false,
      firstDateSelected: false,
      visibleDate: undefined
    };
  },

  computed: {
    isValidFrom() {
      return this.value.from && isValid(this.value.from);
    },

    isValidTo() {
      return this.value.to && isValid(this.value.to);
    },

    selectedDateFrom: {
      get() {
        if (!this.isValidFrom) {
          return undefined;
        }

        return fromUnixTime(this.value.from / MILISECONDS_IN_SECOND);
      },

      set(date) {
        if (this.value.to && isAfter(date, this.value.to)) {
          this.$emit('input', {
            from: this.value.to,
            to: date
          });
        } else {
          this.$emit('input', {
            from: date,
            to: this.value.to
          });
        }
      }

    },
    selectedDateTo: {
      get() {
        if (!this.isValidTo) {
          return undefined;
        }

        return fromUnixTime(this.value.to / MILISECONDS_IN_SECOND);
      },

      set(date) {
        if (this.value.from && isBefore(date, this.value.from)) {
          this.$emit('input', {
            from: date,
            to: this.value.from
          });
        } else {
          this.$emit('input', {
            from: this.value.from,
            to: date
          });
        }
      }

    },

    formattedDateFrom() {
      if (!this.isValidFrom) {
        return '';
      }

      return format(this.value.from, this.dateFormat);
    },

    formattedDateTo() {
      if (!this.isValidTo) {
        return '';
      }

      return format(this.value.to, this.dateFormat);
    },

    dateRange() {
      return {
        from: this.selectedDateFrom,
        to: this.selectedDateTo
      };
    },

    listeners() {
      const {
        focus,
        blur,
        input,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    placeholderDate() {
      return format(new Date(), this.dateFormat);
    }

  },
  watch: {
    isFocused: {
      handler(isFocused) {
        if (isFocused) {
          this.$nextTick(() => this.$refs['input-from'].focus());
        }
      },

      immediate: true
    },

    isOpen() {
      if (!this.isOpen) {
        this.firstDateSelected = false;
      }
    }

  },
  methods: {
    onInputFrom(e) {
      const date = parse(e.target.value, this.dateFormat, new Date()).getTime();

      if (e.target.value.length === 0) {
        this.selectedDateFrom = undefined;
      } else if (!Number.isNaN(date)) {
        const formatted = format(date, this.dateFormat);
        if (e.target.value !== formatted) return;
        this.selectedDateFrom = date;
        this.$nextTick(() => {
          this.visibleDate = this.selectedDateFrom;
        });
      }
    },

    onInputTo(e) {
      const date = parse(e.target.value, this.dateFormat, new Date()).getTime();

      if (e.target.value.length === 0) {
        this.selectedDateTo = undefined;
      } else if (!Number.isNaN(date)) {
        const formatted = format(date, this.dateFormat);
        if (e.target.value !== formatted) return;
        this.selectedDateTo = date;
        this.$nextTick(() => {
          this.visibleDate = this.selectedDateTo;
        });
      }
    },

    toggle() {
      this.isOpen = !this.isOpen;
    },

    onEsc() {
      this.isOpen = false;
    },

    onEnter(e) {
      this.$emit('confirm', e);
    },

    onFocus(e) {
      if (!this.$refs['date-picker'].contains(e.relatedTarget)) {
        this.focused = true;
        this.isOpen = true;
        this.$emit('focus', e);
      }

      const focusedInput = this.getFocusedInput();

      if (focusedInput) {
        this.visibleDate = focusedInput === this.$refs['input-from'] ? this.selectedDateFrom : this.selectedDateTo;
      }
    },

    onBlur(e) {
      if (!this.$refs['date-picker'].contains(e.relatedTarget)) {
        this.focused = false;
        this.isOpen = false;
        this.$emit('blur', e);
      } else if (e.relatedTarget.getAttribute('tabindex') === '-1') {
        e.target.focus();
      }
    },

    onDateSelected(date) {
      if (this.isInputFromFocused()) {
        this.selectedDateFrom = Date.parse(date);
      } else {
        this.selectedDateTo = Date.parse(date);
      }

      if (!this.firstDateSelected) {
        this.firstDateSelected = true;

        if (this.isInputFromFocused()) {
          this.$refs['input-to'].focus();
        } else {
          this.$refs['input-from'].focus();
        }
      } else {
        this.isOpen = false;
      }
    },

    onQuickRange(range) {
      const today = new Date();

      switch (range) {
        case 'this-week':
          return this.setRange(startOfWeek(today), endOfWeek(today));

        case 'this-month':
          return this.setRange(startOfMonth(today), endOfMonth(today));

        case 'last-week':
          return this.setRange(startOfWeek(subWeeks(today, 1)), endOfWeek(subWeeks(today, 1)));

        case 'last-month':
          return this.setRange(startOfMonth(subMonths(today, 1)), endOfMonth(subMonths(today, 1)));

        case 'last-7days':
          return this.setRange(subDays(today, 6), today);

        case 'last-30days':
          return this.setRange(subDays(today, 29), today);

        case 'this-year':
          return this.setRange(startOfYear(today), endOfYear(today));

        case 'last-year':
          return this.setRange(startOfYear(subYears(today, 1)), endOfYear(subYears(today, 1)));
      }

      return undefined;
    },

    setRange(from, to) {
      this.$emit('input', {
        from: getTime(from),
        to: getTime(to)
      });
      this.isOpen = false;
    },

    isInputFromFocused() {
      return document.activeElement === this.$refs['input-from'];
    },

    getFocusedInput() {
      if (document.activeElement === this.$refs['input-from']) return this.$refs['input-from'];
      if (document.activeElement === this.$refs['input-to']) return this.$refs['input-to'];
      return undefined;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/DateRangePicker.vue_rollup-plugin-vue=script.js